export const emailBasicRow = (input: string) => {
  return `<tr><td>${input ?? ""}</td></tr>`;
};
